import { connect } from 'react-redux';
import { eventActions, userActions, alertActions, guestActions } from '../../actions';
import Response from '../../components/public/Response';

const mapStateToProps = (state, ownProps) => {
  const { message, type } = state.alerts;
  return {
    userEvent: state.userEvent.event,
    eventError: state.userEvent.error,
    isLoading: state.userEvent.isLoading,
    guests: state.userGuests.guests,
    guestLoading: state.userGuests.loading,
    // alertMessage: message,
    // alertType: type,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getEvent: (param) => {
      dispatch(eventActions.loadEvent(param))
    },
    createGuest: (event, guest, cb) => {
      dispatch(guestActions.publicAddGuest(event, guest, cb))
    },
    // clearAlert: () => {
    //   dispatch(alertActions.clear());
    // },
    // errorAlert: (message) => {
    //   dispatch(alertActions.error(message));
    // },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Response)
